import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import { NumberBox, TextArea} from 'devextreme-react';
import SelectBox from "../../../../common/CustomSelectBox"
import DateBox from "../../../../common/CustomDateBox"
import { WorkshopAppointmentFactoryTypes, WorkshopAppointmentTypes } from "../../../../../Constantes/worskhopAppointmentTypes";
import CheckBox from 'devextreme-react/check-box';
import { baseRequest } from "../../../../../fetch/basicThunk";
import { QUERY_GET_ITVS_BY_POSTAL_CODE, QUERY_GET_PROVINCE_BY_POSTALCODE } from "../../../../../fetch/constantQueries";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../../../redux/modal/modalSlice";
import { RadioGroup } from 'devextreme-react/radio-group';
import { selectWorkshopAppointmentTemplates, selectWorkshopAppointmentTemplatesLoading } from "../../../../../redux/workshopAppointmentTemplates/selectors";
import { getWorkshopAppointmentTemplates } from "../../../../../redux/workshopAppointmentTemplates/thunks";
import { convertToLocalTime, deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import dayjs from "dayjs";
import { selectCurrentCase } from "../../../../../redux/currentCase/selectors";

function WorkshopAppointmentForm(props){
const {classes, onChange, dataForm} = props;
const [stations, setStations] = useState([])
const dispatch = useDispatch();
const types = useSelector(selectWorkshopAppointmentTemplates);
const typesLoading = useSelector(selectWorkshopAppointmentTemplatesLoading);
const fuelTypes=["Diésel","Gasolina","Otro"];
const numberOfTyres = [2, 4];
const vehicleDocumentationOptions = ["Naranja", "No"]
const tyrePositions =["Delantero", "Trasero"];
const [type, setType] = useState(dataForm?.templateCode)
const [tyrePositionSelectable, setTyrePositionSelectable] = useState(dataForm?.numberOfTyres === 2)
const vipTypes = ["ITV", "Revisión", "Avería", "Chapa", "Neumáticos"]
const currentCase = useSelector(selectCurrentCase)
const [minimunDate, setMinimunDate] = useState();

const acceptMMOptions = ["Sí", "No"]

useEffect(()=>{
    if(dataForm?.numberOfTyres){
        const isSelectable =  dataForm?.numberOfTyres === 2
        setTyrePositionSelectable(isSelectable)
    }   
},[dataForm?.numberOfTyres])

useEffect(()=>{
},[dataForm?.tyrePosition])

useEffect(()=>{
    if(!tyrePositionSelectable) 
        onChange("tyrePosition", null)
},[tyrePositionSelectable])

useEffect(()=>{

    dispatch(getWorkshopAppointmentTemplates());
    setMinimunDate(calculateMinimunVipDate());
    
},[])

useEffect(()=>{
    if(dataForm?.postalCode && (!stations || stations.length ==0)){
        setProvince();
    }
},[])

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    }
},[type, types])

async function fetchProvinceFromPostalCode(postalCode){
    let province;
    try {
        province = await baseRequest({param: postalCode }, dispatch, QUERY_GET_PROVINCE_BY_POSTALCODE, "GET");
    } catch (error) {
        province = null
        onChange("province", null)
        setStations([])
    }
    
    return province
}

async function setProvince(){
    if(!dataForm?.postalCode || dataForm?.postalCode.length < 5 ){
        onChange("province", null); 
        onChange("stationId", null);
        return
    }

    const province = await fetchProvinceFromPostalCode(dataForm?.postalCode);
    
    if(province){
        const provinceHasNewValue = province.name !== dataForm?.province
        if(provinceHasNewValue){
            onChange("stationId", null)
        }
        onChange("province", province.name)
        fetchStations(dataForm?.postalCode)
    } else {
        onChange("stationId", null)
    }
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

async function fetchStations(postalCode){

    try {
        const stations = await baseRequest({param: postalCode }, dispatch, QUERY_GET_ITVS_BY_POSTAL_CODE, "GET")
        if(stations){
            setStations(stations)
        }
    } catch (error) {
        dispatch(openModal({type: "error", message: "No se han podido cargar las ITVs"}))
    }
 

}

function getNotesLabel(){
    let label;
    switch(type){
        case WorkshopAppointmentTypes.FAILURE:
        case WorkshopAppointmentTypes.FAILURE_PLUS_TYRES:
            label = "Motivo avería";
            break;
        case WorkshopAppointmentTypes.MAINTENANCE:
        case WorkshopAppointmentTypes.MAINTENANCE_PLUS_TYRES:
            label = "Motivo mantenimiento";
            break;
        case WorkshopAppointmentTypes.VIP_SERVICE:
            label = "Descrição del interés"
            break;
        default:
            label = "Notas"
    }
    return label
}


function changeVipDate(value){
    let isError = true;
    if(value){
        const isBeforeMinimunDate = dayjs(value).isBefore(minimunDate)
        if(isBeforeMinimunDate){
           changeDateTimeFormat("vipDate", minimunDate)
        } else {
            changeDateTimeFormat("vipDate", value);
            isError = dayjs(value).isSame(minimunDate)? true: false
        }
    }
    if(isError){
        dispatch(openModal({type: "warning", message: `La fecha mínima es ${dayjs(minimunDate).format("DD/MM/YYYY, HH:mm")}`}))
        changeDateTimeFormat("vipDate", minimunDate)
    }
}
function changeDateTimeFormat(field, date){
    const stringDate = dayjs(date).format()
    onChange(field,stringDate)
}

function changeDate(field, date){
    let stringDate = null; 
    if(date){
    stringDate = dayjs(date).format()
    }
    onChange(field,stringDate)
}

function isFactoryType(type){
    const factoryType = WorkshopAppointmentFactoryTypes.some((factoryType)=> factoryType === type);
    return factoryType;
}

function getTemplateIdFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.id
    }
}

function calculateMinimunVipDate(){
        let caseCreationDate = currentCase?.caseId !== 0 ? currentCase?.creationDate : new Date(); // los casos que aún no se han creado en bbdd no tienen fecha de creación, usamos la actual
        const dayOfWeek = new Date(caseCreationDate).getDay();
        const minimunTimeInHours = dayOfWeek > 2 ? 120 : dayOfWeek === 0 ? 96 : 72;
        let minimunDate = dayjs(convertToLocalTime(caseCreationDate)).add(minimunTimeInHours, "hour").toDate()
        return minimunDate
}

function preselectDate(){
        if(!dataForm?.vipDate){
            changeDateTimeFormat("vipDate", minimunDate)
        }
}

function checkIfValidAfterClosing(component){
    const error = component.option("validationError")
    if(error){
        changeVipDate(minimunDate)
        component.option("text", dayjs(minimunDate).format("DD/M/YYYY, HH:mm"))
        component.option("value", minimunDate)
    }
}

function setIsBMW(value){
    if (value === true) {
        onChange("subtype", `${dataForm.templateCode}_bmw`)
    } else {
        onChange("subtype", null)
    }
    onChange("isBMW",value)
}

function setAcceptMM(value){
    if (value === "Sí") {
        onChange("subtype", `${dataForm.subtype}_mm`)
        onChange("acceptMM",value)
    } else {
        if(dataForm.isBMW){
        onChange("subtype", `${dataForm.templateCode}_bmw`)  
        }
        onChange("acceptMM",value)
    }
}

    return(
        <div className={classes.containers} id="workshop-appointment-form">
            <SelectBox label={"Tipología"} disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} ></SelectBox>    
        { !isFactoryType(type) ?
            <>
            <div className={type === WorkshopAppointmentTypes.FAILURE || type=== WorkshopAppointmentTypes.FAILURE_PLUS_TYRES ? "grid-three-columns" : "grid-two-columns"}>
            {(type === WorkshopAppointmentTypes.FAILURE || type=== WorkshopAppointmentTypes.FAILURE_PLUS_TYRES) &&
                <div className="template-checkbox-container">
                    <CheckBox key={"orangeLightPilot"} name="orangeLightPilot" value={dataForm?.orangeLightPilot} onValueChanged={(e) => onChange("orangeLightPilot", e.value)} style={{marginTop: 0}}></CheckBox>
                    <label>Piloto naranja</label>
                </div>
            }
                    <TextBox label={"Código postal"} labelMode="floating"maxLength={5} key={"postalCode"} name="postalCode" value={dataForm?.postalCode} onFocusOut={()=>setProvince()}  onValueChanged={(e) => onChange("postalCode", e.value)}  ></TextBox>
                    <TextBox label={"Provincia"} labelMode="floating"disabled key={"province"} name="province" value={dataForm?.province}  ></TextBox>
            </div>
            { type !== WorkshopAppointmentTypes.ITV &&
                    <TextBox label={"Dirección"} labelMode="floating"key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)}  ></TextBox>
            }
            <div className={"grid-two-columns"}>
            { type !== WorkshopAppointmentTypes.TYRES &&
                    <SelectBox label={"Combustible (sólo BMW e ITV)"} value={dataForm?.fuelType} onValueChanged={(e) => onChange("fuelType",e.value)} placeholder="" dataSource={fuelTypes} showClearButton ></SelectBox>
            }
            { type !== WorkshopAppointmentTypes.ITV &&
                    <NumberBox label={"Kilometraje"} labelMode="floating" type key={"kilometers"} name="kilometers" value={dataForm?.kilometers} onValueChanged={(e) => onChange("kilometers",e.value)}   max={9999999999}></NumberBox>
            }
                    <TextBox label={"Nome"} labelMode="floating"key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)}  ></TextBox>
                    <TextBox label={"Apellidos"} labelMode="floating"key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)}  ></TextBox>
                    <TextBox label={"Móvil"} labelMode="floating"key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}}  ></TextBox>
                    <TextBox label={"Correo electrónico"} labelMode="floating"key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)}  ></TextBox>
                </div>
            {type === WorkshopAppointmentTypes.ITV &&
            <>
                <div className={"grid-two-columns"}>
                 <div className="template-checkbox-container">
                    <CheckBox  key={"itvBonus"} name="itvBonus" value={dataForm?.itvBonus} onValueChanged={(e) => onChange("itvBonus", e.value)}   style={{marginTop: 0}}></CheckBox>
                    <label>Bono ITV</label>
                </div>
                <div className="template-checkbox-container">
                    <CheckBox key={"originalDocItv"} name="originalDocItv" value={dataForm?.originalDocItv} onValueChanged={(e) => onChange("originalDocItv", e.value)}   style={{marginTop: 0}}></CheckBox>
                    <label>Documentación original ITV</label>
                </div>
                </div>
                    <SelectBox value={dataForm?.stationId} valueExpr={"id"} 
                        placeholder={""}
                        label={"Estación"}
                        disabled={!dataForm?.province}
                        searchEnabled
                        onValueChanged={(e) => onChange("stationId",e.value)} 
                        itemRender={(item)=><div className={classes.custom_item}> <span style={{fontWeight: "bold"}}>{item && `${item.city}`}</span>{item? `, ${item?.address ? item.address : ""} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""}</div>}
                        displayExpr={(item)=> item? `${item?.city}, ${item?.address} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""} 
                        dataSource={stations}  
                        noDataText={"No hay opciones disponibles"}>
                    </SelectBox>
             
            </>
            }
            </>
            :
            <>
            <div className={"grid-two-columns"}>
                    <TextBox label={"Nome"} labelMode="floating" key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)}  ></TextBox>
                    <TextBox label={"Apellidos"} labelMode="floating" key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)}  ></TextBox>
                    <TextBox label={"Móvil"} labelMode="floating" key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}}  ></TextBox>
                    <TextBox label={"Correo electrónico"} labelMode="floating" key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)}  ></TextBox>
            </div>
                <TextBox label={"Dirección de recogida"} labelMode="floating" key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)}  ></TextBox>
                <div className="grid-two-columns">
                    <DateBox applyButtonText="Aceptar" min={minimunDate} 
                        isValid={true}
                        label={"Fecha y hora"}
                        displayFormat={"dd/MM/yyyy HH:mm"} 
                        onOpened={()=>preselectDate()}
                        onClosed={(e)=>checkIfValidAfterClosing(e.component)}
                        onFocusOut={(e)=>checkIfValidAfterClosing(e.component)}
                        cancelButtonText="Cancelar" key={"vipDate"} name="vipDate" type="datetime" value={dataForm?.vipDate ? dataForm?.vipDate : null} onValueChanged={(e) => {changeVipDate(e.value)}}  ></DateBox>
                    <SelectBox label={"Tipo de intervención"} value={dataForm?.interventionType}  onValueChanged={(e) => onChange("interventionType",e.value)}placeholder="" dataSource={vipTypes} ></SelectBox>
                </div>
            { dataForm?.interventionType === "ITV" && 
            <div className={"grid-two-columns"}>
                <div className="template-checkbox-container">
                    <CheckBox key={"itvDocumentation"} name="itvDocumentation" value={dataForm?.itvDocumentation} onValueChanged={(e) => onChange("itvDocumentation", e.value)}   style={{marginTop: 0}}></CheckBox>
                    <label>Documentación ITV</label>
                </div>
                <div className="template-checkbox-container">
                    <CheckBox key={"itvBonus"} name="itvBonus" value={dataForm?.itvBonus} onValueChanged={(e) => onChange("itvBonus", e.value)}   style={{marginTop: 0}}></CheckBox>
                    <label>Bono ITV</label>
                </div>
            </div>
            }
            { (dataForm?.interventionType === "Revisión") && 
                <NumberBox label={"Kilómetros actuales"} labelMode="floating" type key={"kilometers"} name="kilometers" value={dataForm?.kilometers} onValueChanged={(e) => onChange("kilometers",e.value)}   max={9999999999}></NumberBox>
            }
            {(dataForm?.interventionType === "Avería" || dataForm?.interventionType === "Revisión") && 
            
                <SelectBox label={"Testigo"} dataSource={vehicleDocumentationOptions} onValueChanged={(e)=>onChange("vehicleControl",e.value)} value={dataForm?.vehicleControl}/>
                
           
            }
            </>
        }
            { (type === WorkshopAppointmentTypes.TYRES ||  type === WorkshopAppointmentTypes.MAINTENANCE_PLUS_TYRES || type === WorkshopAppointmentTypes.FAILURE_PLUS_TYRES || (type === WorkshopAppointmentTypes.VIP_SERVICE && dataForm?.interventionType === "Neumáticos" ) )  &&  
                
                <div className="grid-three-columns">
                    <SelectBox dataSource={numberOfTyres} label={"Número Neumáticos"} onValueChanged={(e)=>onChange("numberOfTyres",e.value)} value={dataForm?.numberOfTyres} />
                    <TextBox label={"Medida Neumáticos"} labelMode="floating"key={"tyreSize"} name="tyreSize" value={dataForm?.tyreSize} onValueChanged={(e) => onChange("tyreSize",e.value)}  ></TextBox>
                    <SelectBox disabled={!tyrePositionSelectable} label={"Posición neumáticos"} dataSource={tyrePositions} value={dataForm?.tyrePosition} onValueChanged={(e)=>onChange("tyrePosition",e.value)}/>
                </div>
            }
             { type === WorkshopAppointmentTypes.TYRES &&
                <div className="grid-two-columns" style={{height: "3rem"}}>
                    <div className="template-checkbox-container">
                        <CheckBox key={"isBMW"} name="isBMW" value={dataForm?.isBMW?dataForm?.isBMW:false} onValueChanged={(e) => setIsBMW(e.value)}></CheckBox>
                        <label>BMW / MINI</label>
                    </div>
                    {dataForm?.isBMW &&
                        <SelectBox label={"¿Acepta MM?"} value={dataForm?.acceptMM} onValueChanged={(e) => setAcceptMM(e.value)} placeholder="" dataSource={acceptMMOptions} ></SelectBox>       
                    }
                </div>
                
             }
            { !isFactoryType(type) &&
            <div className={"grid-two-columns"}>
                                <DateBox label={"Opción 1"} displayFormat={"dd/MM/yyyy HH:mm"}  applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"option1"} name="option1" type="datetime" value={dataForm?.option1} onValueChanged={(e) => changeDate("option1", e.value)}  ></DateBox>
                                <DateBox label={"Opción 2"} displayFormat={"dd/MM/yyyy HH:mm"}  applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"option2"} name="option2" type="datetime" value={dataForm?.option2} onValueChanged={(e) => changeDate("option2",e.value)}  ></DateBox>     
            </div>
            }
            <TextArea label={getNotesLabel()} labelMode="floating" key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)}  height={60}></TextArea>
        </div>
    )
}

export { WorkshopAppointmentForm }